export const propertyNames = {
  STORE_ID: 'storeID',
  ADD_TO_REPAIR: `addToRepair`,
  CUSTOMER_ID: 'customerID',
  CALCULATE_RETAIL_PRICE: 'calculateRetailPrice',
  SHOW_STORE_ITEMS: 'showStoreItems',
  PRODUCT_ID: 'productID',
  CATALOG_ID: 'catalogID',
  ITEM_GROUP_IDS: 'itemGroupIDs',
  HIDE_UNAVAILABLE_ITEMS: 'hideUnavailableItems',
  SORT_BY_PRICE: 'sortByPrice',
  PRICE: 'price',
  ORDER_CODE: 'OrderCode',
  ORDER_STATUS_CODE: 'orderStatusCode',
  HIDE_CLOSED_CONSIGNMENTS: 'hideClosedConsignments',
  INVOICE_CODE: 'InvoiceCode',
  INVOICE_ID: 'InvoiceID',
  USE_RETAIL_PRICES: 'useRetailPrices',
}
